// Toast消息管理器
class ToastManager {
  constructor() {
    this.listeners = [];
    this.toastQueue = [];
    this.isProcessing = false;
    this.lastErrorTime = 0;
    this.lastErrorMessage = '';
    this.ERROR_DEBOUNCE_TIME = 2000; // 2秒内不重复显示相同错误
    // 是否显示非错误类提示（success/warning/info）。默认true，允许显示系统通知
    this.enableNonError = true;
  }

  // 添加监听器
  addListener(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(listener => listener !== callback);
    };
  }

  // 通知所有监听器
  notify(toast) {
    this.listeners.forEach(listener => listener(toast));
  }

  // 检查是否应该显示错误消息（防重复）
  shouldShowError(message) {
    const now = Date.now();
    if (message === this.lastErrorMessage && (now - this.lastErrorTime) < this.ERROR_DEBOUNCE_TIME) {
      console.log('Toast防重复：跳过相同错误消息:', message);
      return false;
    }
    this.lastErrorTime = now;
    this.lastErrorMessage = message;
    return true;
  }

  // 显示Toast消息
  show(message, type = 'info', duration = 3000) {
    // 对于错误类型，检查是否应该显示
    if (type === 'error' && !this.shouldShowError(message)) {
      return;
    }

    const toast = {
      id: Date.now() + Math.random(),
      message,
      type,
      duration,
      visible: true
    };

    this.toastQueue.push(toast);
    this.notify(toast);
    
    // 自动隐藏
    setTimeout(() => {
      this.hide(toast.id);
    }, duration);
  }

  // 隐藏Toast消息
  hide(id) {
    const toast = this.toastQueue.find(t => t.id === id);
    if (toast) {
      toast.visible = false;
      this.notify(toast);
      
      // 从队列中移除
      setTimeout(() => {
        this.toastQueue = this.toastQueue.filter(t => t.id !== id);
      }, 300); // 等待动画完成
    }
  }

  // 判断是否微信环境
  isWechat() {
    return /MicroMessenger/i.test(navigator.userAgent);
  }

  // 便捷方法 - 只保留错误提示
  success(message, duration = 3000) {
    console.log('【toastManager.success】:', { message, duration, typeofMessage: typeof message });
    if (this.enableNonError) {
      this.show(message, 'success', duration);
    } else {
      console.log('成功提示已禁用:', message);
    }
  }

  error(message, duration = 3000) {
    console.log('【toastManager.error】:', { message, duration, typeofMessage: typeof message });
    this.show(message, 'error', duration);
  }

  warning(message, duration = 3000) {
    console.log('【toastManager.warning】:', { message, duration, typeofMessage: typeof message });
    if (this.enableNonError) {
      this.show(message, 'warning', duration);
    } else {
      console.log('警告提示已禁用:', message);
    }
  }

  info(message, duration = 3000) {
    console.log('【toastManager.info】:', { message, duration, typeofMessage: typeof message });
    if (this.enableNonError) {
      this.show(message, 'info', duration);
    } else {
      console.log('信息提示已禁用:', message);
    }
  }

  // 运行时开关：启用/关闭 非错误类提示 的显示
  setEnableNonError(enabled) {
    this.enableNonError = !!enabled;
  }

  // 清除所有Toast
  clear() {
    this.toastQueue.forEach(toast => {
      this.hide(toast.id);
    });
  }

  // 清除错误防重复状态
  clearErrorDebounce() {
    this.lastErrorTime = 0;
    this.lastErrorMessage = '';
  }
}

// 创建全局实例
const toastManager = new ToastManager();

export default toastManager;